/**
 * @file: useVehicleBrandList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useServiceFactory } from '@euler/services/factory';
import { useAutoClearAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useVehicleBrandList = () => {
  const { vehicleInfoService } = useServiceFactory();
  const fetch = useCallback(
    () => vehicleInfoService.getVehicleBrands(),
    [vehicleInfoService],
  );
  return useAutoClearAsyncResource(fetch, 'vehicle-info-lib/brands');
};
